import { render, staticRenderFns } from "./gameRecord.vue?vue&type=template&id=68131485&scoped=true"
import script from "./gameRecord.vue?vue&type=script&lang=js"
export * from "./gameRecord.vue?vue&type=script&lang=js"
import style0 from "./gameRecord.vue?vue&type=style&index=0&id=68131485&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68131485",
  null
  
)

export default component.exports